import { mapKeys, upperFirst } from 'lodash';
export const createToolbarTheme = (toolbarName, theme) => mapKeys(theme, (value, key) => `${toolbarName}${upperFirst(key)}`);
//# sourceMappingURL=utils.js.map